import type { paths } from "@/api-schema";
import { optionsWithDefaults } from "@/common/api/_helpers/options-with-defaults";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { Options } from "../_types";

export const VEHICLE_VALUATION_SETTINGS_RESOURCE = "vehicle-valuation-settings" as const;
export const VEHICLE_VALUATION_SETTINGS_API_PATH = `/v1/${VEHICLE_VALUATION_SETTINGS_RESOURCE}` as const;

export type VehicleValuationSettingsGetParameters =
  paths[typeof VEHICLE_VALUATION_SETTINGS_API_PATH]["get"]["parameters"]["query"];
export type VehicleValuationSettingsGetResponse =
  paths[typeof VEHICLE_VALUATION_SETTINGS_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useVehicleValuationSettingsGetQuery(options?: Options<VehicleValuationSettingsGetParameters, never>) {
  const optionsWithDefaultsResolved =
    optionsWithDefaults<Options<VehicleValuationSettingsGetParameters, never>>(options);
  const requestParameters = optionsWithDefaultsResolved.parameters ?? {};

  return useQuery({
    queryKey: [VEHICLE_VALUATION_SETTINGS_RESOURCE, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<VehicleValuationSettingsGetResponse>(
        VEHICLE_VALUATION_SETTINGS_API_PATH,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
